export const blockObject = ({
  block, blockIndex, section, sectionIndex, field, fieldIndex,
}) => ({
  id: block.id,
  type: block.type,
  lockType: block.lockType,
  formatBlacklist: block.formatBlacklist,
  html: block.html,

  previousBlockId: null,
  nextBlockId: null,

  blockIndex,
  sectionIndex,
  fieldIndex,

  sectionId: section.id,
  sectionType: section.type,
  fieldId: field.id,
});

export const setPreviousBlock = (block, previousBlock) => {
  if (!previousBlock) {
    return;
  }

  // eslint-disable-next-line no-param-reassign
  block.previousBlockId = previousBlock.id;
  // eslint-disable-next-line no-param-reassign
  previousBlock.nextBlockId = block.id;
};
